import './style.css';

function Laoding() {
  return (
   
    <div className="loading">
      <div className='lds-ellipsis'>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    </div >
   
  );
}

export default Laoding;